import React, { memo } from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
import { CheckIcon } from '../../icons';
/**
 * @private
 */
export const ListIcon = /*#__PURE__*/memo(function ListIcon(props) {
  const {
    selected = false,
    disabled = false,
    icon
  } = props;
  if (typeof icon === 'function') return icon({
    selected,
    disabled
  });
  if (typeof icon === 'string') return presetsMapper[icon]({
    selected,
    disabled
  });
  return icon;
});
const presetsMapper = {
  radio: params => (/*#__PURE__*/React.createElement("div", {
    className: clsx(styles.radio, params.selected && styles.selected),
    "data-testid": "radio"
  })),
  'checkbox-indeterminate': params => (/*#__PURE__*/React.createElement("div", {
    className: clsx(styles.checkboxIconContainer, params.selected && styles.selected),
    "data-testid": "checkbox-indeterminate"
  }, /*#__PURE__*/React.createElement("svg", {
    fill: "var(--icon-color)",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "11",
    width: "12",
    height: "2"
  })))),
  checkbox: params => (/*#__PURE__*/React.createElement("div", {
    className: clsx(styles.checkboxIconContainer, params.selected && styles.selected),
    "data-testid": "checkbox"
  }, /*#__PURE__*/React.createElement(CheckIcon, null))),
  check: params => (/*#__PURE__*/React.createElement("div", {
    className: clsx(styles.check, params.selected && styles.selected),
    "data-testid": "check"
  }, /*#__PURE__*/React.createElement(CheckIcon, null)))
};